import * as React from 'react';
import { sprykerProductImageSrcSet } from '../../../../react/common/lib';
import { ISearchSuggestionProductItem } from '../../../interfaces';

interface ISuggestionProductItemProps {
    product: ISearchSuggestionProductItem;
}

const SuggestionProductItem: React.FunctionComponent<ISuggestionProductItemProps> = props => {
    const { product } = props;

    return (
        <div className="search-suggestions-item-product">
            <a className="search-suggestions-item-product-link" href={product.url} />
            <div className="search-suggestions-item-product-image">
                <div className="product-image-cover lazy-image-container">
                    <img
                        alt={product.name}
                        src={product.images.externalUrlThumbnail}
                        className="product-image lazyload"
                        data-src={product.images.externalUrlThumbnail}
                        data-srcset={sprykerProductImageSrcSet(product.images)}
                    />
                </div>
            </div>
            <div className="search-suggestions-item-product-info">
                <div className="search-suggestions-item-product-info-brand">
                    {product.brandName}
                </div>
                <div className="search-suggestions-item-product-info-name">
                    {product.abstractName}
                </div>
            </div>
        </div>
    );
};

export default SuggestionProductItem;
